import React from 'react';
import Header from '../../components/header';
import InvestorPage from './body';
import Footer from '../../components/footer';

function Investor(props) {
    document.title = `Partner With Yebokenny`;
    return (
        <div>
            <Header></Header>
            <InvestorPage></InvestorPage>
            <Footer></Footer>
        </div>
    );
}

export default Investor;